module.exports = __webpack_public_path__ + "static/404-b9e21093288e0891e82636b659caee94.png";